package com.bikompanion.ui.strings

val JaBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "再試行"
    override val actionClose = "閉じる"
    override val actionSubmit = "送信"
    override val detailsLabel = "詳細"
    override val detailsShow = "詳細を表示"
    override val detailsHide = "詳細を非表示"
    override val actionGetDirections = "経路を表示"
    override val actionShareStation = "ステーションを共有"
    override val linkCopied = "リンクをコピーしました"
    override val locateShow = "現在地を表示"
    override val locateFollowHeading = "進行方向に追従"
    override val locateStopFollowing = "追従を停止"
    override val settingsTitle = "設定"
    override val actionBack = "戻る"
    override val settingsAppearance = "外観"
    override val settingsLanguage = "言語"
    override val languageSystem = "システムのデフォルト"
    override val themeSystem = "システム"
    override val themeLight = "ライト"
    override val themeDark = "ダーク"
    override val settingsNotifications = "通知"
    override val stationAlerts = "ステーションのアラート"
    override val notificationsOn = "オン:ウォッチ中のステーションに自転車があるとお知らせします"
    override val notificationsOff = "オフ:ウォッチ中のステーションから通知できません"
    override val notificationsBlocked = "ブロック中:ブラウザのサイト設定で通知を許可してください"
    override val actionManage = "管理"
    override val actionTurnOn = "オンにする"
    override val settingsSupport = "サポート"
    override val sendFeedback = "フィードバックを送信"
    override val sendFeedbackDescription = "問題やステーション情報の誤りをお知らせください"
    override val shareApp = "アプリを共有"
    override val settingsAbout = "概要"
    override val aboutApp = "Bikompanion について"
    override val aboutDevelopedBy = "開発者:Tiago Araujo"
    override val aboutDataSources = "データソース"
    override val sourceCityBikesDescription = "世界中のシェアサイクルネットワーク"
    override val sourceGbfsTitle = "事業者の GBFS フィード"
    override val sourceGbfsDescription = "シェアサイクル事業者のリアルタイムのステーションデータ"
    override val sourceOsmTitle = "OpenStreetMap の貢献者"
    override val sourceOsmDescription = "駐輪場と地図データ"
    override val sourceCartoDescription = "地図タイル"
    override val aboutLegal = "法的情報"
    override val licensesTitle = "オープンソースライセンス"
    override val privacyPolicy = "プライバシーポリシー"
    override val deleteRatings = "自分の評価を削除"
    override val deleteRatingsDescription = "削除のため、匿名IDをメールでお送りいただきます"
    override val licensesLoadFailed = "ライセンス一覧を読み込めませんでした"
    override val aboutVersion = { version: String -> "バージョン $version" }
    override val issueFlatTire = "パンク"
    override val issueFrontBrake = "前ブレーキが効かない"
    override val issueRearBrake = "後ブレーキが効かない"
    override val issueChain = "チェーンが外れる"
    override val issueGears = "変速できない"
    override val issueSeat = "サドルの破損・紛失"
    override val issueLights = "ライトが点かない"
    override val issueLockOrBasket = "鍵またはカゴの破損"
    override val issueFrame = "フレームの破損"
    override val issueMotor = "電動モーターが動かない"
    override val issueBattery = "バッテリーが充電されない"
    override val issueOther = "その他"
    override val networksLoadFailed = "自転車ネットワークを読み込めませんでした。接続を確認してください。"
    override val parkingLoadFailed = "駐輪場を読み込めませんでした"
    override val parkingLoading = "駐輪場を検索中…"
    override val stationsLoading = "ステーションを読み込み中…"
    override val noNetworkHereTitle = "この地域にシェアサイクルはありません"
    override val noNetworkHereHint = "縮小して最寄りのネットワークを探してください"
    override val installTitle = "Bikompanionをインストール"
    override val installHintIos = "共有をタップして、ホーム画面に追加を選んでください。"
    override val installHintAndroid = "Google Playでアプリを入手できます。"
    override val actionInstall = "インストール"
    override val parkingTypeStands = "駐輪ラック"
    override val parkingTypeShed = "駐輪小屋"
    override val parkingTypeLockers = "駐輪ロッカー"
    override val parkingTypeBuilding = "駐輪ビル"
    override val parkingTypeOther = "駐輪場"
    override val fieldAddress = "住所"
    override val fieldCovered = "屋根付き"
    override val fieldYes = "はい"
    override val fieldNo = "いいえ"
    override val fieldId = "ID"
    override val fieldStationId = "ステーションID"
    override val fieldCoordinates = "座標"
    override val fieldCapacity = "収容数"
    override val fieldNetwork = "ネットワーク"
    override val fieldName = "名前"
    override val fieldCity = "都市"
    override val fieldCountry = "国"
    override val fieldCompany = "運営会社"
    override val fieldLicense = "ライセンス"
    override val fieldLicenseUrl = "ライセンスURL"
    override val availabilityBikes = "自転車"
    override val availabilityElectric = "電動"
    override val availabilityEmpty = "空き"
    override val bicingNextPickup = { p0: String -> "次のBicing利用可能まで$p0" }
    override val rateTitle = "自転車を確認・評価"
    override val rateFindingNetworks = "周辺の自転車ネットワークを検索中…"
    override val rateWhatsWrong = "どこが問題ですか？"
    override val rateBikeNumber = "自転車番号"
    override val rateElectricBike = "電動自転車"
    override val rateVoteBad = "悪い"
    override val rateVoteGood = "良い"
    override val rateWhichNetwork = "この自転車はどのネットワークのものですか？"
    override val refreshRateLimited = "リクエスト上限に達しました。自動で再試行します"
    override val refreshFailed = "更新できませんでした"
    override val refreshNextUpdate = { p0: Int -> "次の更新まで${p0}秒" }
    override val refreshUpdating = "更新中…"
    override val dataNone = "データはまだありません"
    override val dataAgeJustNow = "たった今のデータを表示中"
    override val dataAgeMinutes = { p0: Int -> "${p0}分前のデータを表示中" }
    override val dataAgeHours = { p0: Int -> "${p0}時間前のデータを表示中" }
    override val dataAgeDays = { p0: Int -> "${p0}日前のデータを表示中" }
    override val actionOpenOperator = { p0: String -> "${p0}を開く" }
    override val watchNormal = "通常の自転車を監視"
    override val watchElectric = "電動自転車を監視"
    override val watchInstallNormal = "アプリをインストールすると通常の自転車を監視できます"
    override val watchInstallElectric = "アプリをインストールすると電動自転車を監視できます"
    override val watchStopNormal = "通常の自転車の監視を停止"
    override val watchStopElectric = "電動自転車の監視を停止"
    override val actionCheckRateBike = "自転車を確認・評価"
    override val layerStations = "ステーション"
    override val layerParking = "駐輪場"
    override val mapLabelBikes = { p0: Int -> "自転車 ${p0}台" }
    override val mapLabelEbikes = { p0: Int -> "電動 ${p0}台" }
    override val mapLabelFree = { p0: Int -> "空き $p0" }
    override val scoreHeadline = { p0: String, p1: String -> "自転車 $p0 · $p1" }
    override val scoreNoRatings = "まだ評価はありません。最初の評価をどうぞ。"
    override val scoreLooksGood = "良さそうです。"
    override val scoreHasProblems = "この自転車には問題の報告があります。"
    override val scoreMixed = "評価は分かれています。"
    override val ratingNetworkRequired = "先にこの自転車のネットワークを選んでください。"
    override val ratingThanks = { p0: String -> "自転車 $p0 を評価いただきありがとうございます！" }
    override val ratingCooldown = { p0: Int -> "この自転車は最近評価済みです。${p0}分後にもう一度お試しください。" }
    override val ratingQueued = "保存しました。オンラインに戻り次第送信します。"
    override val ratingInvalidBike = "その自転車番号はこのネットワークでは無効です。"
    override val ratingRejected = "評価を保存できませんでした。後でもう一度お試しください。"
    override val notificationFoundTitle = "自転車が利用可能です"
    override val notificationFoundNormal = { p0: String -> "${p0}で通常の自転車が利用可能です" }
    override val notificationFoundElectric = { p0: String -> "${p0}で電動自転車が利用可能です" }
    override val notificationExpiredTitle = "ステーションの監視が終了しました"
    override val notificationExpiredNormal = { p0: String -> "30分経過したため、${p0}の通常の自転車の監視を停止しました" }
    override val notificationExpiredElectric = { p0: String -> "30分経過したため、${p0}の電動自転車の監視を停止しました" }
    override val channelWatchAlertsName = "ステーション監視の通知"
    override val channelWatchAlertsDescription = "自転車の空き状況とステーション監視の更新情報"
    override val channelBackgroundWatchName = "バックグラウンドのステーション監視"
    override val notificationWatchingTitle = "自転車ステーションを監視中"
    override val notificationWatchingText = "選択したステーションをバックグラウンドで監視中"
    override val scoreFewRatings = { count: Int -> "評価はまだ${count}件です。" }
    override val scorePositiveRides = { percent: Int, count: Int -> "直近${count}回の利用で$percent%が高評価" }
}
